<template>
	<div id="class" class="columns">
        Edit this shit!!!
	</div>
</template>

<script>
import Axios from "axios";
//import Icon from "vue-awesome/components/Icon.vue";
import Cookies from "js-cookie";

import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "class",
	created: function() {
		//this.getUnits()
		if (_.isUndefined(this.access == 0)) {
			this.$router.push({
				path: "/"
			});
		}

		this.getCurrentschoolyear();
		this.getReexams();
		this.getSchools();
	},

	data: function() {
		return {
			reexams: [],
			selected_objections: [],
			selected_school: 0,
			studentData: [],
			schools: [],
			currentschoolyear: 0,
			loading: false,
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			isEmpty: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 12
		};
	},
	watch: {},
	methods: {
		getCurrentschoolyear() {
			var self = this;

			instance.get("/current-schoolyear").then(function(response) {
				console.log(response.data.data);

				self.currentschoolyear = response.data.data;
				self.getObjections();
			});
		},
		objection_save(id, value) {
			console.log(id);

			var self = this;
			this.$nextTick(function() {
				// DOM is now updated
				// `this` is bound to the current instance

				console.log(value);
				instance
					.post("/further-education-objection", {
						student_id: id,
						objection_result_id:
							value.tbl_student.tbl_further_education.objection_result_id
					})
					.then(function(response) {
						console.log(response.data.data);
					});
			});
		},
		padwithZeros(string) {
			return _.padStart(string, 2, "0");
		},
		getReexams: function() {
			var self = this;

			this.loading = true;
			instance.get("/reexam").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);

				self.reexams = response.data.data;

				self.loading = false;
			});
		},
		getSchools: function() {
			var self = this;

			instance.get("/school").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);
				console.log(self.Schools);

				var schools = _.remove(response.data.data, function(n) {
					return n.schoolnumber > 0;
				});
				schools = _.sortBy(schools, [
					function(o) {
						return o.schoolnumber;
					}
				]);
				self.schools = schools;
				//self.selected_school = Cookies.get("selected_school");
			});
		},
		handleClick(id) {
			console.log("id: " + id);
			this.$router.push({
				path: "/reexam/" + id
			});
		},
		getSelectedClass: function(id) {
			console.log(id);
			self = this;
			//todo:
			this.loading = true;

			instance.get("/student-class/objection/" + id).then(function(response) {
				console.log(response.data.data);

				self.studentData = response.data.data;

				self.loading = false;
			});
		}
	}
};
</script>
<style scoped>
</style>
